/**
 * sbenedict 5/25 - valid string values for the displayedModal key in Redux.
 * Note that we have many, many modals not listed here as we've been inconsistent with where we define them.
 * With Typescript, in order to typeguard, let's put them all here.
 * I'm not going to hunt down all uses, but as they come up (i.e. when the compiler errors) we should move definitions into this file.
 */
export const MODAL_NAMES = {
  GRID_AVAILABILITY_MODAL: "grid-availability-modal",
  PLANS_DRAWER: "PLANS_DRAWER_MODAL",
  REVIEW_CROP_PHOTOS: "REVIEW_CROP_PHOTOS_MODAL",
  REVIEW_UPLOAD: "REVIEW_UPLOAD_MODAL",
  REVIEW_SUBMIT_SUCCESS: "REVIEW_SUBMIT_SUCCESS_MODAL",
  REVIEW_NUDGE: "REVIEW_NUDGE_MODAL",
  MANAGE_NOTIFICATIONS: "MANAGE_NOTIFICATIONS_MODAL",
  NOTIFY_ME: "NOTIFY_ME_MODAL",
  CUSTOMER_PROMISE_MODAL: "CUSTOMER_PROMISE_MODAL",
  GIFT_CARD_TO_MERCH_CREDITS_MODAL: "GIFT_CARD_TO_MERCH_CREDITS_MODAL",
} as const;
